import { Spine } from '@esotericsoftware/spine-pixi-v7'
import gsap from "gsap"
import * as PIXI from "pixi.js";
import { globalData } from "./globalData";
import { config } from "./appConfig";
// import { Spine as SpineOld } from 'pixi-spine';
import { containers, formatBalance, gameAssets } from "./gameUI";
import { tweenFadeOut, tweenPulsate, tweenPulsateUpgrade, tweenScale } from "./utility";
import { playMeter1 } from "./soundManager";
import { playMeter2 } from "./soundManager";
import { playMeter3 } from "./soundManager";
import { playMeter4 } from "./soundManager";
import { playMeter5 } from "./soundManager";
import { playMeter6 } from "./soundManager";
import { playMeter7 } from "./soundManager";
import { bulbMeter } from "./bulbMeter";

export class meter {

  BulbMeter = null;

  winCounter = 0;
  meterContainer = null;
  meterContents = null;
  multiplierContainer = null;
  meterSpeed = 0.1;

  meterHolder = null;
  meterFill = null;
  meterArrows = null;
  meterSpine = null;

  nextMeterContentPos = 0;
  move = false;

  arrows = [];

  multipliers = {
    2: [0.5, 10],
    3: [0.5, 10],
    4: [0.5, 10],
    5: [0.5, 20],
    6: [0.5, 3, 20],
    7: [0.5, 5, 50],
    8: [0.5, 2, 5, 75],
    9: [0.5, 3, 15, 100],
    10: [0.5, 1, 5, 20, 150],
    11: [0.5, 2, 5, 25, 500],
    12: [0.5, 1, 2, 5, 25, 1000],
  };
  moveDistance = {
    2: 520,
    3: 520,
    4: 520,
    5: 380,
    6: 380,
    7: 285,
    8: 285,
    9: 235,
    10: 235,
    11: 195,
    12: 195,
  };
  multipliersText = [];
  multiplierStartPosition = 0;

  currentMultiplierText = null;
  meterAnimations = [
    "meter_arrow_1",
    "meter_arrow_2",
    "meter_arrow_3",
    "meter_arrow_4",
    "meter_arrow_5",
    "meter_arrow_6",
  ];
  currentAnimation = 0;
  meterArrow = [];
  currentPos = 0;

  meterShine = null;

  upgradeText = null;

  constructor() {
    this.meterContainer = new PIXI.Container();
    this.meterContents = new PIXI.Container();
    this.multiplierContainer = new PIXI.Container();
    this.nextMeterContentPos = this.meterContents.y;

    this.meterHolder = new PIXI.Sprite(PIXI.Assets.get("meter_base"));
    this.meterHolder.anchor.set(0.5);
    this.meterHolder.scale.set(0.9);
    this.meterHolder.position.set(
      config.logicalWidth * 0.91,
      config.logicalHeight * 0.3
    );
    this.meterContainer.addChild(this.meterHolder);

    this.meterFill = new PIXI.Sprite(PIXI.Assets.get("meterBase"));
    // globalData.meterHeightMax = gameAssets.meterFill.height;
    this.meterFill.anchor.set(0.5, 1);
    this.meterFill.y = this.meterFill.height / 2;
    this.meterHolder.addChild(this.meterFill);

    const mask = new PIXI.Sprite(PIXI.Assets.get("meterMask"));
    mask.anchor.set(0.5, 1);
    mask.y = this.meterFill.height / 2;
    this.meterHolder.addChild(mask);

    this.meterArrow[0] = new PIXI.Sprite(PIXI.Assets.get("meterArrows"));
    // globalData.meterHeightMax = gameAssets.meterFill.height;
    this.meterArrow[0].anchor.set(0.5, 1);
    this.meterArrow[0].y = this.meterFill.height / 2;
    this.meterHolder.addChild(this.meterArrow[0]);
    this.meterArrow[0].mask = mask;

    this.meterArrow[1] = new PIXI.Sprite(PIXI.Assets.get("meterArrows"));
    // globalData.meterHeightMax = gameAssets.meterFill.height;
    this.meterArrow[1].anchor.set(0.5, 1);
    this.meterArrow[1].y =
      this.meterFill.height / 2 - this.meterArrow[0].height + 35;
    this.meterHolder.addChild(this.meterArrow[1]);
    this.meterArrow[1].mask = mask;

    this.meterShine = new PIXI.Sprite(PIXI.Assets.get("meterShine"));
    // globalData.meterHeightMax = gameAssets.meterFill.height;
    this.meterShine.anchor.set(0.5, 1);
    this.meterShine.y = this.meterFill.height / 2;
    this.meterHolder.addChild(this.meterShine);

    const meterMask = new PIXI.Sprite(PIXI.Assets.get("gameScreen"));
    meterMask.anchor.set(0.5, 0);
    meterMask.x = config.logicalWidth * 0.91;
    meterMask.height = this.meterHolder.height;
    this.meterContainer.addChild(meterMask);
    this.meterContents.mask = meterMask;

    this.meterContainer.addChild(this.meterContents, this.multiplierContainer);

    // this.meterSpine = new SpineOld(PIXI.Assets.get("meterSpine").spineData);
    this.meterSpine = Spine.from({ skeleton: "meterSpine", atlas: "meterAtlas" });

    this.meterSpine.scale.set(1);
    this.meterSpine.x = this.meterHolder.x;
    this.meterSpine.y = this.meterHolder.y + this.meterHolder.height / 2;
    this.meterSpine.state.setAnimation(0, "meter_arrow_6", true);
    this.meterSpine.state.timeScale = 1;
    this.meterContainer.addChild(this.meterSpine);
    this.meterSpine.visible = false;

    this.BulbMeter = new bulbMeter(this.meterHolder.x, this.meterHolder.y + this.meterHolder.height / 2 - 8.5)
    this.meterContainer.addChild(this.BulbMeter.bulbMeterContainer);
    this.createCurrentMultiplierText();
    //this.moveMeter();
  }
  createMeterContent() {
    console.log("total-rounds", globalData.totalRounds);
    
    if (!globalData.totalRounds) {
      globalData.totalRounds = 5;
      console.log("total-rounds-if", globalData.totalRounds);
    }

    console.log("total-rounds-out-if", globalData.totalRounds);
    
    this.clearMeterContent();
    this.createArrows();
    this.fillFuelBulb();
    this.createMultipliers();
  }

  fillFuelBulb() {
    this.BulbMeter.fuelHolder.alpha = 1;
    this.BulbMeter.fuelHolder.visible = true;
    this.BulbMeter.fillFuel(this.multipliers[globalData.totalRounds].length);
  }
  createArrows() {
    console.log("global.totalround", globalData.totalRounds);
    
    for (
      let i = 0;
      i <
      globalData.totalRounds - this.multipliers[globalData.totalRounds].length;
      i++
    ) {
      this.arrows[i] = new PIXI.Sprite(PIXI.Assets.get("meter_arrow"));
      this.arrows[i].anchor.set(0.5);
      this.arrows[i].scale.set(0.9);
      this.arrows[i].position.set(
        config.logicalWidth * 0.91,
        this.meterFill.y +
        this.meterFill.height / 2 -
        this.moveDistance[globalData.totalRounds] -
        40 -
        i * this.moveDistance[globalData.totalRounds]
      );
      this.meterContents.addChild(this.arrows[i]);
      if (
        i ==
        globalData.totalRounds -
        this.multipliers[globalData.totalRounds].length -
        1
      )
        this.multiplierStartPosition =
          this.meterFill.y +
          this.meterFill.height / 2 -
          this.moveDistance[globalData.totalRounds] -
          50 -
          (i + 1) * this.moveDistance[globalData.totalRounds];
    }
  }
  createCurrentMultiplierText() {
    // const style = new PIXI.TextStyle({
    //     dropShadow: true,
    //     dropShadowAngle: 0,
    //     dropShadowBlur: 0,
    //     dropShadowColor: 0,
    //     dropShadowDistance: 0,
    //     stroke: "#61391E",
    //     strokeThickness: 10,
    //     fill: '#FBAF1F',
    //     fontFamily: 'Arial',
    //     fontSize: 80,
    //     fontWeight: 900,
    //     align: 'center'
    // });

    this.currentMultiplierText = new PIXI.BitmapText(globalData.multiplier, {
      fontName: "normal-font",
      fontSize: 22,
      letterSpacing: -20,
    });

    this.currentMultiplierText.anchor.set(1, 0.5);
    this.currentMultiplierText.y = this.meterHolder.y + this.meterHolder.height / 2 + 2;
    this.currentMultiplierText.x = this.meterHolder.x + 100;
    this.currentMultiplierText.zIndex = 100
    this.meterContainer.addChild(this.currentMultiplierText);
    this.currentMultiplierText.visible = true;

    this.upgradeText = new PIXI.Sprite(PIXI.Assets.get("upgrade"));
    this.upgradeText.anchor.set(0.5);
    this.upgradeText.y = this.meterHolder.y + this.meterHolder.height / 2 - 18;
    this.upgradeText.x = this.meterHolder.x + 6;
    this.upgradeText.zIndex = 101
    this.upgradeText.visible = false;
    this.meterContainer.addChild(this.upgradeText);
    // setTimeout(() => {
    //   tweenPulsateUpgrade(this.upgradeText)
    // }, 3000);
  }
  updateMultiplierText() {
    for (let i = 0; i < this.multipliers[globalData.totalRounds].length; i++) {
      if (this.multipliersText[i]) {
        this.multipliersText[i].text =
          this.multipliers[globalData.totalRounds][
          this.multipliers[globalData.totalRounds].length - i - 1
          ] * globalData.totalBet;
      }
    }
  }

  createMultipliers() {
    for (let i = 0; i < this.multipliers[globalData.totalRounds].length; i++) {
      // const style = new PIXI.TextStyle({
      //     dropShadow: true,
      //     dropShadowAngle: 0,
      //     dropShadowBlur: 0,
      //     dropShadowColor: 0,
      //     dropShadowDistance: 0,
      //     stroke: "#61391E",
      //     strokeThickness: 11,
      //     fill: '#FBAF1F',
      //     fontFamily: 'Arial',
      //     fontSize: 90,
      //     fontWeight: 900,
      //     align: 'center',
      //     letterSpacing: 5,
      //     fontStyle: 'italic'
      // });
      this.multipliersText[i] = new PIXI.BitmapText(
        this.multipliers[globalData.totalRounds][
        this.multipliers[globalData.totalRounds].length - i - 1
        ] * globalData.totalBet,
        {
          fontName: "normal-font",
          fontSize: 20,
          letterSpacing: -15,
        }
      );
      if (
        this.multipliers[globalData.totalRounds][
        this.multipliers[globalData.totalRounds].length - i - 1
        ] >= 1000
      ) {
        this.multipliersText[i].fontName = "gold-font";
        this.multipliersText[i].fontSize = 20;
        this.multipliersText[i].letterSpacing = -15;
      } else if (
        this.multipliers[globalData.totalRounds][
        this.multipliers[globalData.totalRounds].length - i - 1
        ] >= 250
      ) {
        this.multipliersText[i].fontName = "silver-font";
        this.multipliersText[i].fontSize = 20;
        this.multipliersText[i].letterSpacing = -15;
      } else if (
        this.multipliers[globalData.totalRounds][
        this.multipliers[globalData.totalRounds].length - i - 1
        ] >= 100
      ) {
        this.multipliersText[i].fontName = "bronze-font";
        this.multipliersText[i].fontSize = 20;
        this.multipliersText[i].letterSpacing = -15;
      }

      this.multipliersText[i].x = config.logicalWidth * 0.95;
      // this.multipliersText[i].y = this.meterFill.y + this.meterFill.height / 2 - ((this.arrows.length + 1) * this.meterFill.height / globalData.totalRounds) + (i * 50)
      this.multipliersText[i].y =
        this.meterHolder.y - this.meterHolder.height / 2 + 40 + i * 44;
      this.multipliersText[i].anchor.set(1, 0.5);
      this.multiplierContainer.addChild(this.multipliersText[i]);
      //   if (i == 0) this.multiplierStartPosition = this.multipliersText[0].y
    }
  }

  useFuel() {
    this.BulbMeter.useFuel();
  }
  moveMeter(sounds = true) {
    if (
      this.multipliersText[this.multipliersText.length - this.winCounter - 1]
    ) {
      this.multiplierContainer.removeChild(
        this.multipliersText[this.multipliersText.length - this.winCounter - 1]
      );
      this.meterContents.addChild(
        this.multipliersText[this.multipliersText.length - this.winCounter - 1]
      );
      this.multipliersText[
        this.multipliersText.length - this.winCounter - 1
      ].y =
        this.multiplierStartPosition -
        (this.moveDistance[globalData.totalRounds] * this.winCounter);
    }
    //TODO: MAKE AN ARRAY
    this.nextMeterContentPos += this.moveDistance[globalData.totalRounds];
    this.move = true;

    //TODO:UNCOMMENT THIS AFTER
    // if (this.winCounter + 1 >= this.arrows.length) {
    //   tweenPulsate(this.multipliersText[this.multipliersText.length - this.winCounter - 2 + this.arrows.length], 0.8, 1.3)
    // }
    // if (this.currentAnimation < this.arrows.length) {
    //   this.playAnimation(this.currentAnimation);
    // }

    tweenScale(this.arrows[this.winCounter], 1.8, 1.8, 1);
    if (sounds) {
      switch (this.winCounter) {
        case 0:
          playMeter1();
          break;
        case 1:
          playMeter2();
          break;
        case 2:
          playMeter3();
          break;
        case 3:
          playMeter4();
          break;
        case 4:
          playMeter5();
          break;
        case 5:
          playMeter6();
          break;
        default:
          playMeter7();
          break;
      }
    }

    this.winCounter++;
  }

  playAnimation(index) {
    setTimeout(() => {
      this.meterSpine.state.timeScale = 1;
      this.meterSpine.state.setAnimation(0, this.meterAnimations[index], false);
      this.currentAnimation++;
    }, 200);
  }

  clearMeterContent() {
    // this.meterSpine.state.setAnimation(0, '1 number_yellow_out', false)
    // this.meterSpine.state.addListener({
    //     complete: (e) => {
    //     }
    // })
    this.meterSpine.visible = false;
    this.currentAnimation = 0;
    // globalData.multiplier = 0;
    // this.meterSpine.state.setAnimation(0, "meter_arrow_1", true);
    // this.meterSpine.state.timeScale = 0;
    this.move = false;
    // this.inflate = false;
    // this.tweenMultiplier = false;
    this.currentMultiplierText.visible = false;
    this.meterContents.removeChildren();
    this.multiplierContainer.removeChildren();
    this.arrows = [];
    this.arrows.length = 0;
    this.multipliersText = [];
    this.meterContents.y = 0;
    this.currentPos = 0;
    this.nextMeterContentPos = this.meterContents.y;
    this.winCounter = 0;
  }

  showMultiplier() {

    this.meterSpine.visible = true;
    tweenFadeOut(this.BulbMeter.fuelHolder, 1)
    this.BulbMeter.fuelHolder.visible = false;

    if (globalData.prizeUpgrade) {
      this.meterSpine.state.setAnimation(0, "4 number_gold_in", false);
      setTimeout(() => {
        this.meterSpine.state.setAnimation(0, "4 number_gold_loop", true);
        this.currentMultiplierText.visible = false;
        this.currentMultiplierText.text = globalData.multiplier * globalData.totalBet
        this.currentMultiplierText.fontSize = 35;
        this.upgradeText.visible = true;
        tweenPulsateUpgrade(this.upgradeText);
        setTimeout(() => {
          this.upgradeText.visible = false;
          this.currentMultiplierText.visible = true;
        }, 4000);
        setTimeout(() => {
          for (let i = 0; i < globalData.totalRounds - this.winCounter; i++) {
            this.moveMeter();
          }
        }, 1000);

        this.tweenMultiplier = true;
      }, 500);
    } else {
      if (globalData.multiplier >= 1000) {
        this.meterSpine.state.setAnimation(0, "4 number_gold_in", false);
      } else if (globalData.multiplier >= 250) {
        this.meterSpine.state.setAnimation(0, "3 number_silver_in", false);
      } else if (globalData.multiplier >= 100) {
        this.meterSpine.state.setAnimation(0, "2 number_bronze_in", false);
      } else {
        this.meterSpine.state.setAnimation(0, "1 number_yellow_in", false);
      }
      // this.meterSpine.state.addListener({
      //     complete: (e) => {
      //         this.meterSpine.state.setAnimation(0, '1 number_yellow_loop', true)
      //         this.currentMultiplierText.text = globalData.multiplier;
      //         this.currentMultiplierText.visible = true;
      //         this.tweenMultiplier = true;
      //     }
      // })

      setTimeout(() => {
        if (globalData.multiplier >= 1000) {
          this.meterSpine.state.setAnimation(0, "4 number_gold_loop", true);
        } else if (globalData.multiplier >= 250) {
          this.meterSpine.state.setAnimation(0, "3 number_silver_loop", true);
        } else if (globalData.multiplier >= 100) {
          this.meterSpine.state.setAnimation(0, "2 number_bronze_loop", true);
        } else {
          this.meterSpine.state.setAnimation(0, "1 number_yellow_loop", true);
        }

        this.currentMultiplierText.text = globalData.multiplier * globalData.totalBet
        this.currentMultiplierText.fontSize = 35;
        this.currentMultiplierText.visible = true;
        this.tweenMultiplier = true;
      }, 500);
    }
  }
  // tweenMultiplier = false;
  // inflate = false;
  update(delta) {
    // this.meterContents.y += 1
    if (this.winCounter == 0 && this.meterContents.children[this.currentPos] && !this.currentPos) {
      tweenPulsate(this.meterContents.children[this.winCounter], 0.26, 1.1)
      this.currentPos++;
    }
    if (this.meterContents.y < this.nextMeterContentPos && this.move) {
      this.meterContents.children[this.winCounter]?.scale.set(0.85)
      tweenPulsate(this.meterContents.children[this.winCounter], 0.26, 1.1)
      this.meterContents.y += delta * 10;
    } else if (this.move) {
      this.meterContents.y = this.nextMeterContentPos;
      if (this.winCounter > this.arrows.length && this.move) {

        //TODO
        // if(this.BulbMeter.fuelHolder.children.length){
        //   this.BulbMeter.emptyFuel()
        // }
        this.showMultiplier();
        this.currentMultiplierText.scale.set(0.7)
        if (this.currentMultiplierText.text > 999) {
          this.currentMultiplierText.anchor.set(1, 0.5);
          this.currentMultiplierText.x = this.meterHolder.x + 100;
        } else {
          this.currentMultiplierText.anchor.set(0.5);
          this.currentMultiplierText.x = this.meterHolder.x + 5;
        }
        //tweenPulsate(this.currentMultiplierText, 1, 1)
      }
      this.move = false;
    }
    // if (
    //   this.currentMultiplierText.fontSize > 25 &&
    //   this.tweenMultiplier &&
    //   this.inflate
    // ) {
    //   this.currentMultiplierText.fontSize -= delta * 0.25;
    //   if (this.currentMultiplierText.fontSize <= 25) {
    //     this.inflate = false;
    //   }
    // } else if (
    //   this.currentMultiplierText.fontSize < 30 &&
    //   this.tweenMultiplier &&
    //   !this.inflate
    // ) {
    //   this.currentMultiplierText.fontSize += delta * 0.25;
    //   if (this.currentMultiplierText.fontSize >= 30) {
    //     this.inflate = true;
    //   }
    // }

    this.meterArrow.forEach((element) => {
      element.y += 2;
      if (element.y >= this.meterFill.height / 2 + (element.height - 1)) {
        element.y = this.meterFill.height / 2 - (element.height - 1) + 68;
      }
    });
  }

  stopPulsate() {
    gsap.killTweensOf(this.meterContents.children[this.winCounter]);
  }

  startPulsate() {
    this.meterContents.children[this.winCounter]?.scale.set(0.85)
    tweenPulsate(this.meterContents.children[this.winCounter], 0.26, 1.1)
  }
}
